import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcComplianceProps,

    LoadProjectByIdOnly,
    LoadCcApprovalLevels,
    LoadCcResponses,
    LoadCcLibraryItemById,
    LoadCcComplianceHistory,

    setCcApprovalLevelList,
    setCcResponseList,
    setCcModuleResponseList,
    setCcComplianceItemDetails,
    setCcComplianceItemHistory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"

interface ComplianceAnswerProps extends CcComplianceProps {
    projectId: number
}

const ComplianceAnswer = ({
    projectId,
    setId,
    revisionId,
    itemId,
}: ComplianceAnswerProps) => {
    const item = useSelector((state: StoreType) => state.ccCompliance.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        Promise.all([
            LoadProjectByIdOnly(projectId).then((project) => (
                Promise.all([
                    // compliance approval levels
                    LoadCcApprovalLevels(project.accountId, project.id, 1)
                    .then((res) => {
                        dispatch(setCcApprovalLevelList(res.levelList))
                    }),
                    // compliance responses
                    LoadCcResponses(project.accountId, project.id, 1)
                    .then((res) => {
                        dispatch(setCcResponseList(res.responseList))
                        dispatch(setCcModuleResponseList({ 1: res.responseIds }))
                    }),
                    // responsible responses
                    LoadCcResponses(project.accountId, project.id, 0)
                    .then((res) => {
                        dispatch(setCcResponseList(res.responseList))
                        dispatch(setCcModuleResponseList({ 0: res.responseIds }))
                    }),
                ])
            )),
            LoadCcLibraryItemById(itemId, setId).then((res) => {
                dispatch(setCcComplianceItemDetails(res))
            }),
            LoadCcComplianceHistory(itemId, revisionId).then((res) => {
                dispatch(setCcComplianceItemHistory(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
            </PageContent>
        </Container>
    )
}
export default ComplianceAnswer
